import { useEffect, useRef } from "react"
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian_fa from "react-date-object/locales/persian_fa"
import TimePicker from "react-multi-date-picker/plugins/time_picker"
import InputIcon from "react-multi-date-picker/components/input_icon"
import persian from "react-date-object/calendars/persian"
import "react-multi-date-picker/styles/colors/red.css"
import { numberToENG } from "../../tools/functions/Methods"
interface PropType {
  title?: string
  handleChange?: any
  name?: string
  values?: any
  time?: boolean
  timeName?: string
  timeValues?: any
  error?: any
  important?: boolean
  WrapperClassName?: string
  Now?: boolean
  readOnly?: boolean
  minDate?: any
}

const DatePickers = ({
  title,
  name,
  values,
  handleChange,
  time,
  timeValues,
  timeName,
  error,
  important,
  WrapperClassName,
  Now,
  readOnly,
  minDate,
}: PropType) => {
  const timePlugin = [<TimePicker position='bottom' hideSeconds />]
  const datePickerRef = useRef(undefined)
  // window.addEventListener('click',(e)=>{
  //   //@ts-ignore
  //   if (e.target.matches(".dateClass")){
  //     datePickerRef.current.closeCalendar()
  //     e.preventDefault()
  //   }

  // })

  useEffect(() => {
    if (Now) {
      const NowDate = new Date().toLocaleDateString("fa-IR").split("/")
      handleChange(name, {
        day: Number(numberToENG(NowDate[2])),
        month: Number(numberToENG(NowDate[1])),
        year: Number(numberToENG(NowDate[0])),
      })
    }
  }, [Now, handleChange, name])

  const convertToDateObject = (date: {
    year: number
    month: number
    day: number
  }) => {
    if (!date) return undefined
    return new DateObject({
      year: date.year,
      month: date.month,
      day: date.day,
      calendar: persian,
    })
  }

  return (
    <div
      className={`flex flex-col  Max-md:w-full dateClass ${WrapperClassName}`}
    >
      <div
        className={`relative border ${
          error ? "border-red" : "border-darkBorder"
        } rounded-lg w-full ${readOnly && "opacity-40"}`}
      >
        <div
          className={`autocompleteLabel  ${error && "text-red"} z-10 -top-4`}
        >
          {title}{" "}
          <span className='text-tomato font-extrabold text-lg h-4'>
            {important ? "*" : " "}
          </span>
        </div>
        <DatePicker
          minDate={convertToDateObject(minDate)}
          disabled={readOnly}
          className='red z-0'
          calendar={persian}
          name={name}
          value={
            time
              ? `${
                  values?.year + "/" + values?.month + "/" + values?.day
                } ${timeValues}`
              : `${values?.year + "/" + values?.month + "/" + values?.day}`
          }
          locale={persian_fa}
          format={time ? `YYYY/MM/DD HH:mm` : "YYYY/MM/DD"}
          calendarPosition='bottom-right'
          // placeholder={`${values?.day} / ${values?.month} / ${values?.year}       ${time && `${timeValues?.hour}:${timeValues?.minute}`}`}
          onChange={(date: any) => {
            handleChange(name, {
              day: Number(date.day),
              month: Number(date.month),
              year: Number(date.year),
            })
            time && handleChange(timeName, date.hour + ":" + date.minute)
          }}
          render={<InputIcon />}
          plugins={time ? timePlugin : []}
          ref={datePickerRef}
        />
      </div>
      <p className='text-red text-xs pr-3 h-4 mt-1'>{error}</p>
    </div>
  )
}

DatePickers.defaultProps = {
  WrapperClassName: "w-60",
}

export default DatePickers
